document.addEventListener('DOMContentLoaded', () => {
  initLogoStripDots();
  initLogoStripAutoScroll();
});

function initLogoStripDots() {
  if (window.matchMedia('(min-width: 768px)').matches) return;

  const sections = document.querySelectorAll('[data-logo-strip]');

  sections.forEach((section) => {
    const track = section.querySelector('[data-logos-track]');
    const dots = section.querySelectorAll('[data-dot]');

    if (!track || dots.length === 0) return;

    const items = track.querySelectorAll('[data-logo-item]');
    if (!items.length) return;

    const dotMap = new Map();
    dots.forEach((dot) => dotMap.set(dot.dataset.dot, dot));

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          const index = entry.target.dataset.logoItem;
          dots.forEach((dot) => dot.removeAttribute('data-active'));

          const activeDot = dotMap.get(index);
          if (activeDot) activeDot.dataset.active = 'true';
        });
      },
      { root: track, threshold: 0.5 }
    );

    items.forEach((item) => observer.observe(item));
  });
}

function initLogoStripAutoScroll() {
  const viewports = document.querySelectorAll('[data-auto-scroll]');
  if (!viewports.length) return;

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  viewports.forEach((viewport) => {
    const track = viewport.querySelector('[data-auto-scroll-track]');
    if (!track) return;

    if (prefersReducedMotion) {
      track.style.transform = 'translate3d(0, 0, 0)';
      return;
    }

    const durationSeconds = parseFloat(viewport.dataset.scrollDuration) || 40;
    let contentWidth = track.scrollWidth / 2;
    let pxPerMs = contentWidth / (durationSeconds * 1000);
    let offset = 0;
    let lastTime = null;
    let inViewport = true;
    let pageVisible = !document.hidden;

    const recalculate = () => {
      contentWidth = track.scrollWidth / 2;
      pxPerMs = contentWidth / (durationSeconds * 1000);
    };

    const tick = (time) => {
      if (lastTime === null) lastTime = time;
      const delta = time - lastTime;
      lastTime = time;

      if (inViewport && pageVisible && contentWidth > 0) {
        offset += pxPerMs * delta;
        if (offset >= contentWidth) offset -= contentWidth;
        track.style.transform = `translate3d(-${offset}px, 0, 0)`;
      }

      requestAnimationFrame(tick);
    };

    requestAnimationFrame(tick);
    window.addEventListener('load', recalculate);

    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(recalculate, 200);
    });

    const visibilityObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          inViewport = entry.isIntersecting;
          lastTime = null;
        });
      },
      { threshold: 0 }
    );
    visibilityObserver.observe(viewport);

    document.addEventListener('visibilitychange', () => {
      pageVisible = !document.hidden;
      lastTime = null;
    });
  });
}
